// src/services/library/author.ts
import { LibraryStatsType } from "../../types/Library";
import { get } from "../../utils/axios-config";
import { LIBRARY_STATS } from "../../utils/constants";

export const getLibraryStats = async () => {
    return await get<LibraryStatsType>(LIBRARY_STATS);
};
